import Filters from '@components/Filters/Filters';
import Footer from '@components/Footer';
import LeftNavbar from '@components/LeftNavBar';
import TopNavbar from '@components/TopNavBar';
import { companyEntityList } from '@/store/companyEntity/companyEntityThunk';
import { fetchActiveTransactionIds } from '@/store/global/globalThunks';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { RootState } from '@store/store';
import { useEffect, useMemo, useState } from 'react';

import {
  ContentWrapper,
  LeftSideBarContainer,
  MainContent,
  MainWrapper,
  NavBarContainer,
} from './styles';
import { Props } from './types';

const Layout = ({ children, addFiltersComponent = true }: Props) => {
  const SIDEBAR_STORAGE_KEY = 'sidebarOpen';

  const dispatch = useAppDispatch();
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const companyEntities = useAppSelector(
    (state: RootState) => state.companyEntity.entityList,
  );
  const activeTransactionIds = useAppSelector(
    (state: RootState) => state.global.activeTransactionIds,
  );

  const entityIds = useMemo(
    () => (companyEntities ?? []).map((e) => e.comp_entity_id),
    [companyEntities],
  );

  useEffect(() => {
    if (!isAuthenticated) return;
    if (entityIds.length === 0) dispatch(companyEntityList(null));
    if (activeTransactionIds.length === 0) dispatch(fetchActiveTransactionIds());
  }, [dispatch, isAuthenticated]);

  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(() => {
    const saved = localStorage.getItem(SIDEBAR_STORAGE_KEY);
    return saved !== null ? JSON.parse(saved) : true;
  });

  const handleSidebarToggle = (
    value: boolean | ((prev: boolean) => boolean),
  ) => {
    setIsSidebarOpen((prev) => {
      const next = typeof value === 'function' ? value(prev) : value;
      localStorage.setItem(SIDEBAR_STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  };

  return (
    <MainWrapper className="main-wrapper-content">
      <LeftSideBarContainer $isOpen={isSidebarOpen}>
        <LeftNavbar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={handleSidebarToggle}
        />
      </LeftSideBarContainer>
      <ContentWrapper $isOpen={isSidebarOpen}>
        <NavBarContainer>
          <TopNavbar />
          {isAuthenticated && addFiltersComponent && <Filters />}
        </NavBarContainer>
        <MainContent className="main-content">{children}</MainContent>
        <Footer />
      </ContentWrapper>
    </MainWrapper>
  );
};

export type { Props };
export default Layout;
